/* eslint-disable import/prefer-default-export */
export const normalizeFileNameMixin = {
  methods: {
    /*
    * Parse a filename to determine if it matches the tech comm naming convention
    * Returns a more friendly/readable display name for the file
    */
    normalizeFileName(value) {
      // sanity check
      if (!value) return '-';

      // split the value on hyphen
      const titleSplit = value.split('-');
      const fileId = titleSplit.slice(0, 4).join('-');
      const regex = RegExp(/(\d{3}-\d{5}-\d{3}-rev(\d{1,2}|\w{1,2}))/, 'gi');
      let isTechFile = false;

      // check if we're looking at tech file or not
      if (regex.test(fileId)) {
        isTechFile = true;
      }
      // file name format not recognized, just return the value
      if (!isTechFile) return value;
      // this may be impossible but just in case
      if (titleSplit.length == 0) return value;
      // remove the first 4 items
      titleSplit.splice(0, 4);
      // re-join with spaces
      const title = titleSplit.join(' ');
      // now split on . and remove last part
      const titleParts = title.split('.');
      titleParts.pop();
      const returnResult = `${titleParts.join('.')} (${fileId})`;
      return returnResult;
    }
  }
}
